import Cookies from "universal-cookie";

const cookies = new Cookies();
const BASE = process.env.BACKOFFICE_SERVER_URL || "";

const clientError = ({ status, code, message, retryable = false }) => ({
  status,
  code,
  message,
  retryable,
});

const configuredUrl = (path) => {
  if (!BASE) {
    throw clientError({
      status: 0,
      code: "configuration_error",
      message: "Backoffice não configurado.",
    });
  }
  try {
    const base = new URL(BASE);
    if (!new Set(["https:", "http:"]).has(base.protocol) || base.username || base.password) {
      throw new Error();
    }
    const basePath = base.pathname.replace(/\/+$/, "");
    return new URL(`${basePath}/${path}`, `${base.origin}/`);
  } catch {
    throw clientError({
      status: 0,
      code: "configuration_error",
      message: "Backoffice não configurado.",
    });
  }
};

const aiAccessFetch = async (path, { method = "GET", body, idempotencyKey } = {}) => {
  const url = configuredUrl(path);
  const { token } = cookies.get("userId") || {};
  let response;
  try {
    response = await fetch(url.toString(), {
      method,
      headers: {
        Authorization: `Bearer ${token}`,
        ...(body === undefined ? {} : { "Content-Type": "application/json" }),
        ...(idempotencyKey ? { "Idempotency-Key": idempotencyKey } : {}),
      },
      body: body === undefined ? undefined : JSON.stringify(body),
    });
  } catch {
    throw clientError({
      status: 0,
      code: "network_error",
      message: "Não foi possível comunicar com o servidor.",
      retryable: true,
    });
  }

  const data = await response.json().catch(() => null);
  if (!response.ok) {
    throw clientError({
      status: response.status,
      code: typeof data?.errorCode === "string" ? data.errorCode : "request_failed",
      message: typeof data?.message === "string"
        ? data.message
        : "Não foi possível concluir a operação.",
      retryable: response.status >= 500,
    });
  }
  return data;
};

const segment = (value) => encodeURIComponent(String(value));

export const fetchAiPlans = () => aiAccessFetch("ai-plans");

export const createAiPlan = (plan) => aiAccessFetch("ai-plans", {
  method: "POST",
  body: plan,
});

export const updateAiPlan = (planKey, plan) => aiAccessFetch(
  `ai-plans/${segment(planKey)}`,
  { method: "PATCH", body: plan },
);

export const fetchAiWorkAccess = (companyId) => {
  const query = new URLSearchParams({ company_id: String(companyId) });
  return aiAccessFetch(`ai-work-access?${query.toString()}`);
};

export const updateAiWorkAccess = (workId, mutation) => aiAccessFetch(
  `ai-work-access/${segment(workId)}`,
  { method: "PATCH", body: mutation },
);

export const fetchAiUsage = (workId) => {
  const query = new URLSearchParams({ work_id: String(workId) });
  return aiAccessFetch(`ai-usage?${query.toString()}`);
};

export const resetAiUsage = (workId, reset, { idempotencyKey } = {}) => aiAccessFetch(
  `ai-usage/${segment(workId)}/reset`,
  { method: "POST", body: reset, idempotencyKey },
);

export default {
  fetchAiPlans,
  createAiPlan,
  updateAiPlan,
  fetchAiWorkAccess,
  updateAiWorkAccess,
  fetchAiUsage,
  resetAiUsage,
};
